(() => {
  const controllerKey = '__protonV1GalleryController';
  window[controllerKey]?.abort();

  const controller = new AbortController();
  window[controllerKey] = controller;

  const normalizeColor = (value) => {
    const color = String(value || '').trim().toLowerCase();
    if (color.includes('cream')) return 'cream';
    if (color.includes('blue')) return 'blue';
    return 'pink';
  };

  const imageSource = (thumb, color) => {
    if (thumb.dataset.src) return thumb.dataset.src;
    return thumb.dataset[`${color}Src`] || thumb.dataset.pinkSrc;
  };

  const selectThumb = (gallery, thumb) => {
    const color = normalizeColor(gallery.dataset.color);
    const main = gallery.querySelector('[data-gallery-main]');
    if (!main) return;

    gallery.querySelectorAll('[data-gallery-thumb]').forEach((candidate) => {
      candidate.setAttribute('aria-current', String(candidate === thumb));
    });
    main.src = imageSource(thumb, color);
    main.alt = `Project ${gallery.dataset.family} — ${thumb.dataset.label}`;
  };

  const selectRequestedGalleryImage = (gallery) => {
    const requestedKey = new URLSearchParams(window.location.search).get('gallery');
    if (!requestedKey) return;
    const requestedThumb = [...gallery.querySelectorAll('[data-gallery-thumb]')]
      .find((thumb) => thumb.dataset.galleryKey === requestedKey);
    if (requestedThumb) selectThumb(gallery, requestedThumb);
  };

  const updateFlamingoColor = (colorValue) => {
    const color = normalizeColor(colorValue);
    const displayColor = String(colorValue || '').trim() || 'Pink';
    document.querySelectorAll('[data-proton-v1-gallery][data-family="flamingo"]').forEach((gallery) => {
      gallery.dataset.color = color;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const image = thumb.querySelector('img');
        if (image) image.src = imageSource(thumb, color);
      });
      const active = gallery.querySelector('[data-gallery-thumb][aria-current="true"]') || gallery.querySelector('[data-gallery-thumb]');
      if (active) selectThumb(gallery, active);
    });

    document.querySelectorAll('[data-flamingo-color-image]').forEach((image) => {
      const source = image.dataset[`${color}Src`] || image.dataset.pinkSrc;
      if (source) image.src = source;
    });

    document.querySelectorAll('[data-flamingo-family-link]').forEach((link) => {
      const href = link.dataset[`${color}Href`] || link.dataset.pinkHref;
      if (href) link.href = href;
    });

    document.querySelectorAll('[data-flamingo-selected-color]').forEach((label) => {
      label.textContent = displayColor;
    });
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-proton-v1-gallery]');
    if (gallery) selectThumb(gallery, thumb);
  }, { signal: controller.signal });

  document.querySelectorAll('[data-proton-v1-gallery]').forEach(selectRequestedGalleryImage);

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker || !document.querySelector('.proton-flamingo')) return;
    const name = String(event.target.name || event.target.closest('fieldset')?.querySelector('legend')?.textContent || '').toLowerCase();
    if (name.includes('color')) updateFlamingoColor(event.target.value);
  }, { signal: controller.signal });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-proton-v1-gallery]').forEach(selectRequestedGalleryImage);
    document.querySelectorAll('[data-proton-v1-gallery][data-family="flamingo"]').forEach((gallery) => updateFlamingoColor(gallery.dataset.color));
  }, { signal: controller.signal });
})();
